export const CONTRACT_ADDRESS = "0x1acd678c7c82175f609bed8166675eb45c61c365";
export const TRANSACTION_BASE_URL = "https://etherscan.io/tx/";
export const MINT_FEE = 0;
